import queryString from '../../../helpers/queryString';
import Axios from 'axios';
import handleErrorResponse from '../../../helpers/handleErrorResponse';
import { push } from 'react-router-redux';
import { get, set } from 'lodash';

const SUBMIT_CONTENT = 'socrates-online/organisation/campaign-banner/SUBMIT_CONTENT';
const FINISH_SUBMITTING =
  'socrates-online/organisation/campaign-banner/FINISH_SUBMITTING';
const SET_CAMPAIGN_BANNER =
  'socrates-online/organisation/campaign-banner/SET_CAMPAIGN_BANNER';
const SET_CAMPAIGN_BANNERS =
  'socrates-online/organisation/campaign-banner/SET_CAMPAIGN_BANNERS';

const initialState = {
  isSubmitting: false,
};

export function reducer(state = initialState, action) {
  switch (action.type) {
    case SUBMIT_CONTENT:
      return {
        ...state,
        isSubmitting: true,
      };
    case FINISH_SUBMITTING:
      return {
        ...state,
        isSubmitting: false,
      };
    case SET_CAMPAIGN_BANNER:
      return {
        ...state,
        currentCampaignBanner: action.payload,
      };
    case SET_CAMPAIGN_BANNERS:
      return {
        ...state,
        banners: action.payload,
      };
    default:
      return state;
  }
}

const submitForm = (formValues) => {
  const resource = set(formValues, 'data.relationships.files.data', [
    get(formValues, 'data.relationships.files.data'),
  ]);

  return (dispatch) => {
    dispatch({
      type: SUBMIT_CONTENT,
    });

    const endpoint = 'contents/';

    return Axios.post(endpoint, resource)
      .then(() => {
        dispatch(push('/admin/campaign-banners/'));
        dispatch({
          type: FINISH_SUBMITTING,
        });
        return true;
      })
      .catch((error) => {
        handleErrorResponse(error, 'There was an error creating your content');
      });
  };
};

const getCampaignBanner = (id, includes = ['files', 'campaign', 'template']) => {
  return (dispatch) => {
    let endpoint = 'contents/' + id;
    endpoint += queryString(includes);

    return Axios.get(endpoint)
      .then((response) => {
        dispatch({
          type: SET_CAMPAIGN_BANNER,
          payload: response.data,
        });
        return true;
      })
      .catch((error) => {
        console.error(error);
      });
  };
};

const getCampaignBanners = () => {
  return (dispatch) => {
    const endpoint = 'contents?page[limit]=10&filter[template.key]=campaign-banner';

    return Axios.get(endpoint)
      .then((response) => {
        dispatch({
          type: SET_CAMPAIGN_BANNERS,
          payload: response.data,
        });
        return true;
      })
      .catch((error) => {
        console.error(error);
      });
  };
};

const updateCampaignBanner = (formValues, includes = ['template', 'files']) => {
  const resource = set(formValues, 'data.relationships.files.data', [
    get(formValues, 'data.relationships.files.data'),
  ]);

  return (dispatch) => {
    dispatch({
      type: SUBMIT_CONTENT,
    });

    const endpoint = 'contents/' + resource.data.id + queryString(includes);

    return Axios.patch(endpoint, resource)
      .then(() => {
        dispatch(push('/admin/campaign-banners/'));
        dispatch({
          type: FINISH_SUBMITTING,
        });
        return true;
      })
      .catch((error) => {
        handleErrorResponse(error, 'There was an error updating your content');
      });
  };
};

const endCampaignBanner = (bannerId) => {
  return (dispatch) => {
    const endpoint = 'contents/' + bannerId + ':end';

    return Axios.post(endpoint).then(() => {
      dispatch(push('admin/campaign-banners/'));
    });
  };
};

export const actions = {
  submitForm,
  getCampaignBanner,
  getCampaignBanners,
  updateCampaignBanner,
  endCampaignBanner,
};
